import { render, staticRenderFns } from "./EditPercepcionMaternidad.vue?vue&type=template&id=529c647f&scoped=true&"
import script from "./EditPercepcionMaternidad.vue?vue&type=script&lang=js&"
export * from "./EditPercepcionMaternidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c647f",
  null
  
)

export default component.exports